import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import React from 'react';

export function confirmDelete(title: string, onOk: () => void) {
  Modal.confirm({
    title,
    icon: <ExclamationCircleOutlined />,
    content: 'Thao tác này không thể hoàn tác.',
    okText: 'Xóa',
    okType: 'danger',
    cancelText: 'Hủy',
    onOk,
  });
} 